import { surface, ink, border, focus } from "../UI/tokens";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { btnReset, v } from "../../styles/variables";

export const SSidebar = styled.div`
  flex: 0 0 ${({ 'data-isopen': open }) => open ? '280px' : '80px'};
  width: ${({ 'data-isopen': open }) => open ? '280px' : '80px'};
  min-width: 0; padding: 24px 12px;
  background: ${surface}; color: ${ink};
  border-right: 1px solid ${border}; position: relative;
  box-shadow: 4px 0 24px rgba(15,23,42,.025);
  @media (max-width: 768px) {
    flex: none; width: 100%; padding: 16px;
    border-right: 0; border-bottom: 1px solid ${border};
  }
`;

export const SSidebarButton = styled.button`
  ${btnReset};
  position: absolute; top: 40px; right: -14px; z-index: 2;
  display: flex; align-items: center; justify-content: center;
  width: 28px; height: 28px; border-radius: 8px;
  background: ${surface}; color: ${ink}; border: 1px solid ${border};
  box-shadow: 0 2px 6px rgba(15,23,42,.08); cursor: pointer;
  transform: ${({ 'data-isopen': open }) => open ? 'none' : 'rotate(180deg)'};
  ${focus}
  @media (max-width: 768px) { top: 20px; right: 16px; }

`;

export const SSidebarButtonLogout = styled.button`
    ${btnReset};
    display: none;

    @media (max-width: 768px) {
        display: block;
        width: 6vw;
        margin-top: -2vh;
        margin-right: 3vw;
        position: absolute;
        right: 1vw;
    }

  color: ${ink}; ${focus}
  @media (max-width: 768px) {
    top: 20px; right: 60px; width: 32px; height: 32px; margin: 0;
  }
`;

export const SLogo = styled.div`
  display: flex; align-items: center; justify-content: center;
  min-height: 72px; margin-bottom: 24px; padding-bottom: 20px;
  border-bottom: 1px solid ${border};
  @media (max-width: 768px) {
    justify-content: flex-start; min-height: 52px; margin-bottom: 12px;
    padding: 0 90px 12px 0;
  }
`;

export const ResponsiveImage = styled.img`
    display: block;
    margin: 0 auto;
    width: ${(props) => (props['data-isopen']  ? `5vw` : '50px')};

    @media (max-width: 768px) {
        width: 25vw;
    }

  width: ${({ 'data-isopen': open }) => open ? '104px' : '44px'};
  max-width: 100%; height: auto; object-fit: contain;
  @media (max-width: 768px) { width: 72px; margin: 0; }
`;

export const SSearch = styled.div`
    background: ${({ theme }) => theme.bgAlpha};
    border: 1px solid ${({ theme }) => theme.bg3};
    border-radius: ${v.borderRadius};
    input {
        padding: 0 ${v.smSpacing};
        font-family: inherit;
        letter-spacing: inherit;
        font-size: 16px;
        width: 100%;
        outline: none;
        border: none;
        color: inherit;
        background: transparent;
    }
    display: flex;
`;

export const SSearchIcon = styled.button`
    ${btnReset};
    padding: calc(${v.mdSpacing} - 2px) ${v.mdSpacing};
    display: flex;
    cursor: pointer;

    svg {
        font-size: 20px;
    }
`;

export const SDivider = styled.div`
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.bg3};
    margin: ${v.lgSpacing} 0;
`;

export const SLinkDescription = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    width: auto;
    `;

export const SLinkContent = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    width: auto;
`;

export const SSubMenu = styled(Link)`
    align-items: center;
    text-decoration: none;
    color: inherit;
    top: 0; /* Posiciona o submenu abaixo do item clicado */
    left: 0; /* Alinha o submenu com o item clicado */
    background-color: ${({ theme }) => theme.bg}; /* Cor de fundo do submenu */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Sombra do submenu */
    z-index: 1; /* Garante que o submenu esteja acima de outros elementos */
    width: 100%; /* Largura do submenu (ajuste conforme necessário) */
    padding: 8px; /* Espaçamento interno do submenu (ajuste conforme necessário) */
    border-radius: 4px; /* Bordas arredondadas do submenu (ajuste conforme necessário) */
    display: ${(props) => (props['data-isopen'] ? "block" : "none")}; /* Exibe o submenu somente se isOpen for verdadeiro */
`;

export const SLink = styled(Link)`
    /* position: relative; */
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
    font-size: 16px;
    padding: calc(${v.smSpacing} - 2px) 0;
`;

export const SLinkLabel = styled.span`
    display: block;
    flex: 1;
    margin-left: ${v.smSpacing};
`;

export const SLinkNotification = styled.div`
    font-size: 14px;
    padding: calc(${v.smSpacing} / 2) ${v.smSpacing};
    border-radius: calc(${v.borderRadius} / 2);
    background: ${({ theme }) => theme.primary};
    color: white;

    margin-right: ${v.mdSpacing};
`;

export const STheme = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
`;

export const SThemeLabel = styled.span`
    display: block;
    flex: 1;
`;

